export default __webpack_public_path__ + "static/granulation-a889bdd7f6d0a2237809a0130a1881c5.png";